export * from './structure';
export * from './header';
export * from './notifications';
export * from './schedule';

export {
    ERROR_CANCEL_REFUND,
    ERROR_CANCEL_REFUND_WITH_BULK_ENABLED,
} from '../event/api';

export const GA_TRACKING_EVENT_CATEGORY = 'create-event';
export const ACTION_EVENT_PUBLISH = 'EventPublished';
export const LABEL_NEW_CREATE = 'coyote';

export const GA_GOAL_CATEGORY = 'goal';
export const ACTION_PUBLISH = 'Publish';
export const ACTION_INCREMENTAL_PUBLISH = 'IncrementalPublish';
export const ACTION_FIRST_PUBLISH = 'FirstPublish';
export const ACTION_FIRST_PAID_PUBLISH = 'FirstPaidPublish';
export const ACTION_FIRST_COYOTE_PUBLISH = 'FirstCoyotePublish';
export const ACTION_FIRST_COYOTE_PAID_PUBLISH = 'FirstCoyotePaidPublish';
export const ACTION_EVENT_PREVIEW = 'EventPreview';
export const GA_EVENT_PUBLISHED = 'EventPublished';

export const GA_SALES_STATUS_ACTION_POSTPONE_CONFIRMED =
    'PostponeEventStatusConfirmed';

// Marketing Tools Experiment
export const VARIANT_C = 'C';

export const EVENT_DASHBOARD_BASE = '/myevent';
